import BasicContentAttachment from './BasicContentAttachment';

export { type BasicContentAttachmentProps } from './BasicContentAttachment';
export default BasicContentAttachment;
